import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Users, Sparkles, FolderTree, Lock } from "lucide-react";

const STEPS = [
  { icon: Users, title: "Ask the Council", text: "Pose one question to 3 different AI models at once — GPT, Claude, and Gemini answer in parallel." },
  { icon: Sparkles, title: "Get a Synthesis", text: "A powerful Synthesizer agent weighs every answer and crafts one clear, balanced response." },
  { icon: FolderTree, title: "Build Insight", text: "Save, tag, and connect sessions over time into structured Insight Worksheets." },
];

export default function Landing() {
  return (
    <div>
      <section className="max-w-6xl mx-auto px-5 pt-16 pb-12 md:pt-24 md:pb-20 grid md:grid-cols-2 gap-12 items-center">
        <div className="fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-bold uppercase tracking-[0.15em]"
            style={{ background: "#EFF6FF", color: "#2563EB" }}>
            <Sparkles size={13} /> Multi-Agent AI Council
          </span>
          <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.05]" style={{ color: "#1E293B" }}>
            Your personal AI knowledge synthesizer.
          </h1>
          <p className="mt-6 text-lg leading-relaxed max-w-xl" style={{ color: "#475569" }}>
            Ask one question to a council of AI models, get a single balanced answer, and watch your
            questions connect into structured insight over time. Private by design — everything stays in your browser.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/ask" data-testid="get-started-btn"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-xl font-bold text-white transition-colors duration-200"
              style={{ background: "#2563EB" }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "#1D4ED8")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "#2563EB")}>
              Get Started <ArrowRight size={18} />
            </Link>
            <Link to="/about" data-testid="learn-more-btn"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-xl font-bold border transition-colors duration-200"
              style={{ borderColor: "#CBD5E1", color: "#1E293B", background: "#fff" }}>
              Learn more
            </Link>
          </div>
          <p className="mt-5 inline-flex items-center gap-2 text-sm" style={{ color: "#94A3B8" }}>
            <Lock size={14} /> 5 sessions free · then $5 once · no subscriptions
          </p>
        </div>
        <div className="fade-up" style={{ animationDelay: "0.1s" }}>
          <div className="rounded-2xl overflow-hidden border shadow-sm" style={{ borderColor: "#CBD5E1" }}>
            <img src="https://images.pexels.com/photos/5712576/pexels-photo-5712576.jpeg"
              alt="A calm notebook and pen on a clean desk" className="w-full h-[360px] object-cover" />
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-5 pb-20">
        <div className="grid md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <div key={s.title} className="rounded-2xl border bg-white p-8 shadow-sm fade-up"
              style={{ borderColor: "#CBD5E1", animationDelay: `${0.15 + i * 0.08}s` }}>
              <div className="grid place-items-center w-12 h-12 rounded-xl mb-5" style={{ background: "#EFF6FF" }}>
                <s.icon size={22} color="#2563EB" />
              </div>
              <h3 className="text-xl font-bold tracking-tight" style={{ color: "#1E293B" }}>{s.title}</h3>
              <p className="mt-2 leading-relaxed" style={{ color: "#475569" }}>{s.text}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
